import { ClmmPositionExpanded, TokenListMetadata } from "@bridgesplit/abf-sdk";

/** Token-metadata lookup, as returned by `useTokenListContext().getMetadata`. */
export type GetTokenMetadata = (mint: string | undefined | null) => TokenListMetadata | undefined;

export interface TokenBalance {
    metadata: TokenListMetadata;
    amount: number;
}

export interface TokenBalanceExpanded extends TokenBalance {
    key: string; // used as a unique key in ui for inputs/loops
    clmmPosition?: ClmmPositionExpanded | null;
}

export enum TokenRestrictionCode {
    GeneralDisabled = "generalDisabled",
    UsMarketHours = "usMarketHours",
    UsFxMarketHours = "usFxMarketHours",
    AssetPool = "assetPool",
    CountryRestricted = "countryRestricted"
}

export enum TokenRestrictedActions {
    All = "all",
    Borrow = "borrow",
    Repay = "repay",
    Lend = "lend",
    LoopStart = "loopStart",
    LoopClose = "loopClose",
    WithdrawCollateral = "withdrawCollateral"
}

export interface Restriction {
    restrictionCode: TokenRestrictionCode;
    restrictedActions: TokenRestrictedActions[];
    customErrorMessage?: string;
    customWarningMessage?: string;
    isActive: boolean;
    link?: string;
}

export interface TokenRestrictionResponse {
    mint: string;
    restrictions: Restriction[];
}

export interface TokenRestrictionsRequest {
    mints?: string[]; // For parity with backend, though FE doesn't use it (wants all)
    countryCode?: string;
}

export interface RestrictionExpanded extends Restriction {
    token: TokenListMetadata | undefined;
}
